// tslint:disable:max-line-length
import * as React from 'react';

import { createIcon } from '../icon';

export const BuiltAreaPure = createIcon(`
<svg version="1.1" id="Слой_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="120" height="120"
	 viewBox="0 0 120 120" style="enable-background:new 0 0 120 120;" xml:space="preserve">
<style type="text/css">
	.built-area0{fill:none;stroke:#FF4114;stroke-width:2.6562;stroke-miterlimit:10;}
	.built-area1{fill:none;stroke:#1D1D1B;stroke-width:2.6562;stroke-miterlimit:10;}
	.built-area1{fill:none;stroke:#0A055F;stroke-width:2.6562;stroke-miterlimit:10;}
</style>
<g>
	<line class="built-area0" x1="85.6" y1="44.3" x2="35.2" y2="44.3"/>
	<line class="built-area0" x1="85.7" y1="61" x2="35.2" y2="61"/>
	<line class="built-area0" x1="35.3" y1="27.3" x2="35.3" y2="77.8"/>
	<line class="built-area0" x1="51.9" y1="27.3" x2="51.9" y2="77.8"/>
	<line class="built-area0" x1="68.6" y1="27.3" x2="68.6" y2="77.8"/>
	<line class="built-area1" x1="85.3" y1="27.3" x2="85.3" y2="77.8"/>
	<line class="built-area0" x1="35.3" y1="77.8" x2="35.3" y2="112.2"/>
	<line class="built-area0" x1="51.8" y1="77.7" x2="51.8" y2="117.5"/>
	<line class="built-area0" x1="68.1" y1="77.7" x2="68.1" y2="117.5"/>
	<line class="built-area0" x1="101" y1="77.6" x2="101" y2="100.6"/>
	<line class="built-area0" x1="14.6" y1="94.4" x2="35.3" y2="94.4"/>
	<polyline class="built-area0" points="14.6,95.3 14.6,61.1 35.3,61.1 35.3,112.2 	"/>
	<line class="built-area0" x1="14.6" y1="77.8" x2="114.7" y2="77.8"/>
	<polyline class="built-area0" points="35.3,112.2 35.3,27.3 85.3,27.3 85.3,111.7 	"/>
	<path class="built-area1" d="M2.5,60c0,31.7,25.8,57.5,57.5,57.5s57.5-25.8,57.5-57.5S91.7,2.5,60,2.5S2.5,28.3,2.5,60"/>
	<path class="built-area1" d="M117.5,60c0,31.7-25.8,57.5-57.5,57.5S2.5,91.7,2.5,60S28.3,2.5,60,2.5S117.5,28.3,117.5,60z"/>
</g>
</svg>
`);

export const BuiltAreaIcon: React.SFC<{ iconClassName?: string }> = (props: { iconClassName?: string }) => (
  <BuiltAreaPure className={props.iconClassName} />
);

BuiltAreaIcon.displayName = 'BuiltAreaIcon';
